import { Currency } from "./currencies";

/** A two-dimensional dictionary mapping of every currency to every currency to an exchange rate */
export type ExchangeRates<
  From extends Currency = Currency,
  To extends Currency = Currency,
> = { [T in From]: { [T in To]: number } };

export class Money {
  constructor(
    readonly amount: number,
    readonly currency: Currency,
  ) {}
}
